import { DateTime } from 'luxon';
import { z } from 'zod';

import { parseTimestamp } from '../lib/date-time.js';

const suppressionDtoSchema = z.object({
  id: z.string(),
  deviceId: z.string(),
  detectionGroupId: z.string().nullish(),
  detectionGroupcreatedAt: z.string().nullish(),
  type: z.enum(['analog', 'digital']),
  channelFrequency: z.number(),
  success: z.boolean(),
  isStopped: z.boolean(),
  reason: z.string().nullish(),
  bandwidth: z.number().nullish(),
  startedAt: z.string().nullish(),
  finishedAt: z.string().nullish(),
  createdAt: z.string(),
});

export const suppressionSchema = suppressionDtoSchema.transform((suppression) => ({
  id: suppression.id,
  deviceId: suppression.deviceId,
  detectionGroupId: suppression.detectionGroupId,
  detectionGroupCreatedAt: suppression.detectionGroupcreatedAt,
  type: suppression.type,
  channelFrequency: suppression.channelFrequency,
  success: suppression.success,
  isStopped: suppression.isStopped,
  reason: suppression.reason,
  bandwidth: suppression.bandwidth,
  startedAt: parseTimestamp(suppression.startedAt),
  finishedAt: parseTimestamp(suppression.finishedAt),
  createdAt: parseTimestamp(suppression.createdAt) as DateTime,
}));

export const suppressionListSchema = z.object({
  suppressions: z.array(suppressionSchema),
});

export type Suppression = z.infer<typeof suppressionSchema>;
